
export const isProduction = process.env.NODE_ENV === 'production';

export const getApiUrl = () => isProduction
    ? (process.env.VUE_APP_API_URL || 'https://makairs.stationsoft.net/api')
    : 'http://localhost:8002';
